import { Input, InputGroup } from "rsuite";
import React from "react";
import {TfiSaveIcon} from "../../../../../../models/Icons.model";
import DeviceParameterSyncButton from "../../../../../shared/DeviceParameterSyncButton/DeviceParameterSyncButton";
import {ExternalDeviceType} from "../../../ExternalDevices.model";
import {ExternalDevicesUtils} from "../../../ExternalDevices.utils";

type DeviceData = {
  article?: string | null;
  model?: string | null;
  place?: string | null;
  firmwareVersion?: string | number | null;
  fabricDate?: string | null;
  serialNumber?: string | null;
};

type UspInfoSectionProps = {
  deviceData: DeviceData;
  deviceId: string;
  onChangePlace?: (value: string) => void;
  onChangeArticle?: (value: string) => void;
  onChangeModel?: (value: string) => void;
  loading?: boolean;
  onSavePlace?: () => void;
  onSaveArticle?: () => void;
  onSaveModel?: () => void;
  onRefreshDeviceInfo?: () => void | Promise<void>;
  isAdmin?: boolean;
};

const UspInfoSection = ({
  deviceData,
  deviceId,
  onChangePlace,
  onChangeArticle,
  onChangeModel,
  loading,
  onSavePlace,
  onSaveArticle,
  onSaveModel,
  onRefreshDeviceInfo,
  isAdmin
}: UspInfoSectionProps) => {
  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <InputGroup>
            <InputGroup.Addon>Артикул</InputGroup.Addon>
            <Input
              size="md"
              value={deviceData.article || ""}
              onChange={onChangeArticle}
            />
            {isAdmin && (
              <InputGroup.Addon>
                <TfiSaveIcon
                  style={{ cursor: "pointer" }}
                  onClick={onSaveArticle}
                  className={loading ? "loading" : ""}
                />
              </InputGroup.Addon>
            )}
          </InputGroup>
        </div>
        <div className="col-md-4">
          <InputGroup>
            <InputGroup.Addon>Модель</InputGroup.Addon>
            <Input
              size="md"
              value={deviceData.model || ""}
              onChange={onChangeModel}
            />
            {isAdmin && (
              <InputGroup.Addon>
                <TfiSaveIcon
                  style={{ cursor: "pointer" }}
                  onClick={onSaveModel}
                  className={loading ? "loading" : ""}
                />
              </InputGroup.Addon>
            )}
          </InputGroup>
        </div>
        <div className="col-md-4">
          <InputGroup>
            <InputGroup.Addon>Место установки</InputGroup.Addon>
            <Input
              size="md"
              value={deviceData?.place || ""}
              onChange={onChangePlace}
            />
            {isAdmin && (
              <DeviceParameterSyncButton
                deviceId={deviceId}
                parameter="Place"
                onSynced={onRefreshDeviceInfo}
              />
            )}
            <InputGroup.Addon>
              <TfiSaveIcon
                style={{ cursor: "pointer" }}
                onClick={onSavePlace}
                className={loading ? "loading" : ""}
              />
            </InputGroup.Addon>
          </InputGroup>
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-md-4">
          <InputGroup>
            <InputGroup.Addon>Версия прошивки:</InputGroup.Addon>
            <Input
              size="md"
              value={deviceData.firmwareVersion || ""}
            />
            {isAdmin && (
              <DeviceParameterSyncButton
                deviceId={deviceId}
                parameter="FirmwareVersion"
                onSynced={onRefreshDeviceInfo}
              />
            )}
          </InputGroup>
        </div>
        <div className="col-md-4">
          <InputGroup>
            <InputGroup.Addon>Дата производства:</InputGroup.Addon>
            <Input
              size="md"
              value={deviceData.fabricDate || ""}
            />
          </InputGroup>
        </div>
        <div className="col-md-4">
          <InputGroup>
            <InputGroup.Addon>Серийный номер:</InputGroup.Addon>
            <Input
              size="md"
              value={ExternalDevicesUtils.formatDeviceSerialNumber(deviceData.serialNumber, ExternalDeviceType.UpsI)}
            />
          </InputGroup>
        </div>
      </div>
    </>
  );
};

export default UspInfoSection;
